import React from "react";

import { SignatureSuccess as StyledSignatureSuccess } from "./SignatureSuccess.styles.js";
import { formatCpf, formatCnpj } from '../../utils/formatter';
import Icon from '../../components/Icon';

import Loading from "../../components/Loading";
import SignboxLogo from "../../assets/images/signbox.svg"
import successPure from "../../assets/images/success-pure.svg"

function SignatureSuccess ({ document, exportPdf, loading }) {
	if (!document || loading) {
		return <Loading />
	}

	return (
		<StyledSignatureSuccess>
			<StyledSignatureSuccess.Center>
				<StyledSignatureSuccess.Logo><StyledSignatureSuccess.Image src={SignboxLogo} /></StyledSignatureSuccess.Logo>
			</StyledSignatureSuccess.Center>

			<StyledSignatureSuccess.Center>
				<StyledSignatureSuccess.ImageSuccess src={successPure} />
			</StyledSignatureSuccess.Center>

			<StyledSignatureSuccess.Center>
				<StyledSignatureSuccess.Container>
					<StyledSignatureSuccess.Title>O documento foi assinado com sucesso</StyledSignatureSuccess.Title>
					<StyledSignatureSuccess.Text>Enviamos sua resposta para {document?.company?.name}. </StyledSignatureSuccess.Text>
				</StyledSignatureSuccess.Container>
			</StyledSignatureSuccess.Center>

			<StyledSignatureSuccess.Footer>
				<StyledSignatureSuccess.ContainerCenter>
					<StyledSignatureSuccess.SignatureBox src={document.signature_url} />
				</StyledSignatureSuccess.ContainerCenter>

				<StyledSignatureSuccess.ContainerCenter>
					<StyledSignatureSuccess.UserName>{document?.destinatary?.name}</StyledSignatureSuccess.UserName>
					<StyledSignatureSuccess.Cpf>{document?.destinatary?.cpf ? formatCpf(document?.destinatary?.cpf) : formatCnpj(document?.destinatary?.cnpj)}</StyledSignatureSuccess.Cpf>
				</StyledSignatureSuccess.ContainerCenter>

				<StyledSignatureSuccess.Center>
					<StyledSignatureSuccess.Button disabled={loading} onClick={exportPdf} className="af-button af-button--secondary">
						<Icon name='download-button' marginRight={8} />
						<StyledSignatureSuccess.ButtonText>Baixar documento</StyledSignatureSuccess.ButtonText>
					</StyledSignatureSuccess.Button>
				</StyledSignatureSuccess.Center>
			</StyledSignatureSuccess.Footer>
		</StyledSignatureSuccess>
	)
}

export default SignatureSuccess;
